// Wait for DOM.
$(() =>
{
    // Get overlay
    let siteOverlay = localStorage.getItem('siteOverlay') || false;
    showDebugOverlay(siteOverlay);

    // On debug click
    $(document).on('click', '.core\\:\\:common-ResponsiveDebug .debug', (event) => {
        let visibleToggle =  !$('.website\\:\\:layouts-main-Creation').is(':visible');

        // Set site overlay in local storage
        localStorage.setItem('siteOverlay', visibleToggle);

        showDebugOverlay(visibleToggle);
    });

    function showDebugOverlay(siteOverlay)
    {
        // Show site overlay?
        if( siteOverlay === "true" || siteOverlay === true ) {
            // Hide or show overlay
            $('.website\\:\\:layouts-main-Creation')
                .show();
        } else {
            $('.website\\:\\:layouts-main-Creation')
                .hide();
        }
    }

});
